function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#009A6C",
  d: "M0,80C0,35.816,35.817,0,80,0s80,35.816,80,80c0,44.183-35.817,80-80,80S0,124.183,0,80"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M61.454,111.5c-0.171,0-0.342-0.011-0.514-0.033c-1.229-0.159-2.316-0.88-2.941-1.951L40.093,78.817 c-1.114-1.908-0.47-4.357,1.438-5.471c1.909-1.114,4.359-0.469,5.471,1.439l15.293,26.217l51.33-51.331 c1.563-1.563,4.095-1.563,5.657,0c1.563,1.562,1.563,4.095,0,5.656l-55,55C63.527,111.083,62.508,111.5,61.454,111.5"
});

var SvgConfermaAccent = function SvgConfermaAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.665 -0.416 161 161",
    enableBackground: "new -0.665 -0.416 161 161",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConfermaAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/conferma_accent.f078b07a.svg";
export { ForwardRef as ReactComponent };